import { bool, func, string } from 'prop-types';
import React from 'react';

import Button from 'shared/components/button/Button';
import ArchiveIcon from 'shared/components/icon/Archive';

const ArchiveButton = ({ label, enabled, onClick }) => (
  <Button
    className="block-button block-button--action block-button--archive"
    disabled={!enabled}
    onClick={onClick}
  >
    <div className="block-button__inner">
      <ArchiveIcon />
      {label}
    </div>
  </Button>
);

ArchiveButton.propTypes = {
  label: string.isRequired,
  enabled: bool.isRequired,
  onClick: func.isRequired,
};

export default ArchiveButton;
